export default __webpack_public_path__ + "static/media/downArrow.9b337654.svg";